// BiztantuMobileFooter.jsx

import React from "react";
import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DEFAULT_PAGE_SIZE, ROWS_PER_PAGE_OPTIONS } from "../Utility/constant";
const BiztantuSearchPageFooter = ({
  paginationState,
  pagedData,
  onPageChange,
  onPageSizeChange,
}) => {
  const page = paginationState?.page ?? 0;
  const size = paginationState?.size ?? DEFAULT_PAGE_SIZE;

  const totalElements = pagedData?.totalElements ?? 0;
  const totalPages = pagedData?.totalPages ?? 0;
  return (
    <Box
      className = "mobile-footer"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontSize={13}>
          {totalElements} Records
        </Typography>

        <Box display="flex" alignItems="center" gap={1}>
          <Typography fontSize={13}>
            Rows:
          </Typography>

          <Select
            size="small"
            value={size}
            onChange={(e) =>
              onPageSizeChange(Number(e.target.value))
            }
          >
            {ROWS_PER_PAGE_OPTIONS.map((item) => (
                <MenuItem key={item} value={item}>
                {item}
                </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <IconButton
          disabled={page === 0}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeftIcon />
        </IconButton>

        <Typography fontSize={14}>
          Page {page + 1} of {Math.max(totalPages, 1)}
        </Typography>

        <IconButton
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default BiztantuSearchPageFooter;